import React, { useState } from 'react';
import { Spin, Alert, Row, Col, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useDocument, useDocumentChunks } from '@/shared/hooks/useKnowledgeQueries';
import ChunksListPanel from './components/ChunksListPanel';
import DocumentInfoPanel from './components/DocumentInfoPanel';
import ChunkDetailPanel from './components/ChunkDetailPanel';

interface DocumentChunksViewerProps {
  documentId: string;
  onBackToList: () => void;
}

const DocumentChunksViewer: React.FC<DocumentChunksViewerProps> = ({
  documentId,
  onBackToList
}) => {
  const [selectedChunkIndex, setSelectedChunkIndex] = useState<number>(0);

  const { data: documentData, isLoading: docLoading, error: docError } =
    useDocument(documentId);
  const { data: chunksData, isLoading: chunksLoading, error: chunksError } =
    useDocumentChunks(documentId);

  if (docLoading || chunksLoading) return <Spin size="large" />;
  if (docError || chunksError) return <Alert type="error" message="加载失败" />;

  const selectedChunk = chunksData?.chunks?.find(
    chunk => chunk.chunk_index === selectedChunkIndex
  );

  return (
    <div>
      {/* 返回按钮 */}
      <div style={{ marginBottom: 16 }}>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={onBackToList}
        >
          返回文档列表
        </Button>
      </div>

      {/* 主内容区域 */}
      <Row gutter={24} style={{ height: 'calc(100vh - 220px)' }}>
        <Col xs={24} md={14} lg={16}>
          <ChunksListPanel
            chunks={chunksData?.chunks || []}
            selectedIndex={selectedChunkIndex}
            onSelect={setSelectedChunkIndex}
          />
        </Col>
        <Col xs={24} md={10} lg={8}>
          <DocumentInfoPanel document={documentData} />
          <div style={{ marginTop: 16 }}>
            <ChunkDetailPanel chunk={selectedChunk} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DocumentChunksViewer;